import axios from 'axios'
import Vue from 'vue'
import router from '@/router/index'
import store from '@/store/index'
import {
	queryConfig
} from '@/api/urls'

//所有页面是否显示视频内容
export function getHideVideo(type) {
	// console.log(type, "是否显示视频内容,0 存储 1跳转")
	// type 0 存储 1跳转
	queryConfig().then(({
		code,
		data,
		msg
	}) => {
		if (code === 200) {
			// console.log(data, "data公共js是否显示视频内容")
			// site_closevideo=1是关闭视频。0开启。
			if (type == 1) {
				// 返回首页跳转页面
				if (data.site_closevideo == 1) {
					// 首页被隐藏了 跳转到游戏页面
					router.push({
						name: 'games'
					})
				} else {
					router.push({
						name: 'index'
					})
				}
			} else {
				if (data.site_closevideo == 1) {
					store.commit('setHideVideo', true)
				} else {
					store.commit('setHideVideo', false)
				}

			}

		}
	})
}


// WEBPACK FOOTER //
// ./src/assets/wap/js/hideJs.js